import { cloneWorkflow as clone } from 'api/WorkflowsAPI';
import { FolderId } from 'modules/domains/foldering';
import type { AppDispatch } from 'modules/app/components/App';

import { addPositiveToast, addNegativeToastWithErrorId } from 'modules/toastContainer';

import { Workflow, WorkflowId, WorkflowType } from '../types';

const displayText = {
  failure: 'Could not copy journey',
  success: 'Successfully copied journey',
};

export const cloneWorkflow = async (
  workflow: Workflow,
  destinationFolderId: FolderId,
  dispatch: AppDispatch,
  name = '',
) => {
  try {
    const cloneParams: {
      workflowId: WorkflowId;
      workflowType?: WorkflowType;
      destinationFolderId?: FolderId;
      name: string;
    } = {
      workflowId: workflow.id,
      workflowType: workflow.workflowType,
      destinationFolderId,
      name,
    };
    await clone(cloneParams);
    dispatch(addPositiveToast(displayText.success));
  } catch (e) {
    dispatch(addNegativeToastWithErrorId(displayText.failure, 'cloneWorkflow'));
  }
};
